// Inject the <video> when the frame approaches the viewport, play muted, pause when out of view.
if (!customElements.get('video-background')) customElements.define('video-background', class extends HTMLElement {
  connectedCallback() {
    const tpl = this.querySelector('[data-video-template]'); if (!tpl) return;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting && !this.video) { this.mount(tpl); }
      else if (this.video) { if (e.isIntersecting) this.tryPlay(); else this.video.pause(); }
    }), { rootMargin: '300px' });
    io.observe(this);
  }

  mount(tpl) {
    this.appendChild(tpl.content.cloneNode(true));
    this.video = this.querySelector('video');
    this.video.muted = true;                       // the only state a browser will autoplay
    this.classList.add('is-muted');
    // Reveal on the PLAYING event, never on the play() promise: iOS refuses programmatic autoplay
    // (Low Power Mode above all) and the video would otherwise run at opacity 0 behind the poster.
    this.video.addEventListener('playing', () => this.classList.add('is-playing'));
    this.video.addEventListener('play', () => this.classList.remove('is-paused'));
    this.video.addEventListener('pause', () => this.classList.add('is-paused'));

    // Play only, and shown only while paused: this is an editorial background film, not a player.
    // Pausing it is what the sound button is for — silence is the thing a reader actually wants back.
    const play = this.querySelector('[data-video-play]');
    if (play) play.addEventListener('click', (e) => { e.stopPropagation(); this.tryPlay(); });

    const sound = this.querySelector('[data-video-sound]');
    if (sound) sound.addEventListener('click', (e) => {
      e.stopPropagation();
      this.video.muted = !this.video.muted;
      this.classList.toggle('is-muted', this.video.muted);
      sound.setAttribute('aria-label', sound.dataset[this.video.muted ? 'labelOn' : 'labelOff']);
      // Unmuting is a user gesture, so this is the one moment an autoplay-refused video can also start.
      if (!this.video.muted && this.video.paused) this.tryPlay();
    });

    this.tryPlay();
  }

  // A refused play() leaves the poster and the play button; the button's tap is a gesture and always works.
  tryPlay() { this.video.play().catch(() => this.classList.add('is-paused')); }
});
